import secureLocalStorage from "react-secure-storage";

const base_url = process.env.REACT_APP_BASE_URL;

/**
 * Handle 401 Unauthorized - redirect to login
 */
const handleUnauthorized = () => {
    // Clear stored credentials
    secureLocalStorage.removeItem('token');
    secureLocalStorage.removeItem('customerId');
    secureLocalStorage.removeItem('customerName');
    secureLocalStorage.removeItem('customerEmail');
    secureLocalStorage.removeItem('customerPhone');

    // Redirect to account/login page
    window.location.href = '/account';
};

const HttpRequest = async ({ method, url, body, timeout = 30000, headers: extraHeaders }) => {
    let token = secureLocalStorage.getItem('token');

    let finalUrl = `${base_url}${url}`
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...(extraHeaders || {})
    };
    if (token) {
        headers['X-Authorization'] = token;
    }

    // Abort hung requests instead of letting the browser wait for minutes
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);

    return fetch(finalUrl, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
        signal: controller.signal
    }).then((res) => {
        const status = res.status;
        // Try to parse as JSON, but handle non-JSON responses
        const json = res.text().then(text => {
            try {
                return text ? JSON.parse(text) : {};
            } catch (e) {
                console.warn('Response is not valid JSON:', text);
                return { error: text || 'Invalid response format' };
            }
        });
        return Promise.all([status, json]);
    }).then(([status, data]) => {
        // Handle 401 Unauthorized - token expired or invalid
        if (status === 401) {
            console.warn('Unauthorized (401) - Token expired. Redirecting to login...');
            handleUnauthorized();
            return { status, response: data };
        }
        return { status, response: data };
    }).catch((error) => {
        console.error('HttpRequest error:', error);
        const message = error.name === 'AbortError' ? 'Request timed out' : (error.message || 'Network error');
        return { status: 500, response: { error: message } };
    }).finally(() => {
        clearTimeout(timer);
    });
};

export { HttpRequest };
